"use client";

import { Hit as AlgoliaHit } from "instantsearch.js";
import { useEffect } from "react";
import { useHits, useInstantSearch } from "react-instantsearch";

import { css } from "@/../styled-system/css";
import { useSearchStore } from "@/providers/search-store-provider";

import SearchTip from "./SearchTip";
import SearchProductCard from "../Navbar/SearchProductCard";
import CustomHitsSkeleton from "./skeleton/CustomHitsSkeleton";

type HitData = {
  name: string;
  avg_price: number;
  image_url: string;
  slug: string;
  objectID: string;
};

const customHitsContainerClass = css({
  position: "absolute",
  backgroundColor: "white",
  zIndex: "2",
  left: "0",
  right: "0",
  bottom: "0",
  width: "100%",
  overflow: "auto",
  top: "164px",
  sm: {
    top: "96px",
  },
});

const searchProductGridClass = css({
  display: "grid",
  gridGap: "2",
  justifyContent: "space-between",
  xs: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  sm: {
    gridTemplateColumns: "repeat(3, 1fr)",
    gridGap: "4",
  },
  md: {
    gridTemplateColumns: "repeat(4, 1fr)",
    gridGap: "6",
  },
  xl: {
    gridTemplateColumns: "repeat(5, 1fr)",
    gridGap: "6",
  },
});

const noHitsContainerClass = css({
  mx: "auto",
  backgroundColor: "neutral.200",
  p: "3",
  width: "90%",
  height: "fit-content",
});

function CustomHits() {
  const { hits, sendEvent } = useHits<AlgoliaHit<HitData>>();
  const { query: storeQuery } = useSearchStore((state) => ({
    query: state.query,
  }));
  const { status } = useInstantSearch();

  useEffect(() => {
    if (storeQuery !== "") {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [storeQuery]);

  if (storeQuery === "") {
    return null;
  }

  if (status === "loading" || status === "stalled") {
    return <CustomHitsSkeleton />;
  }

  if (status === "idle" && hits.length === 0) {
    return (
      <div className={customHitsContainerClass}>
        <div className={noHitsContainerClass}>
          <p className={css({ fontSize: "xl", fontWeight: "medium" })}>
            No search results found. Please modify your query.
          </p>
        </div>
      </div>
    );
  }

  if (status === "idle" && hits.length > 0) {
    return (
      <div className={customHitsContainerClass}>
        <div className={css({ pb: "5" })}>
          <div
            className={css({
              maxWidth: "1628px",
              width: "90%",
              margin: "0 auto",
            })}
          >
            <div className={searchProductGridClass}>
              {hits.map((hit) => (
                <SearchProductCard
                  key={hit.objectID}
                  name={hit.name}
                  avg_price={hit.avg_price}
                  slug={hit.slug}
                  image_url={hit.image_url}
                  objectId={hit.objectID}
                  sendEvent={sendEvent}
                  hit={hit}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomHits;
